import { ActionIcon, Box, Button, Card, ScrollArea } from '@mantine/core'
import React, { useRef, useState } from 'react'
import { Timeline, Text } from '@mantine/core';
import { useEffect } from 'react';
import { fullDate } from '../../utils/reusedfunctions';
import { useFullscreen } from '@mantine/hooks';
import { MdFullscreen } from 'react-icons/md';

const AlarmCard = (props) =>
{
    const { data, screensize } = props
    const [updatedData, setUpdatedData] = useState([])
    const { ref, toggle, fullscreen } = useFullscreen();
    const len = data.data

    // const actualData = updatedData.slice(0, 6)

    useEffect(() =>
    {
        // const newData = data.data.slice(0, 6)
        // const actualData = newData.reverse()

        setUpdatedData(prevData => [...data.data, ...prevData])



        // }
    }, [data, len])

    return (
        <Card padding="lg" shadow="xs" radius="md" ref={ref}>

            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text size="md" className='subcardHeading'>{data.title}</Text>
                {screensize ? null : <ActionIcon onClick={toggle} ><MdFullscreen size={"2rem"} /></ActionIcon>}
            </Box>

            {/* <ScrollArea h={400} > */}
            <Timeline active={updatedData.length} bulletSize={10} lineWidth={2} ml={30} p={30}>

                {/* <div>{JSON.stringify(updatedData)}</div> */}
                {

                    updatedData.slice(0, 6).reverse().map((message) =>
                    {
                        const time = message.TimeStamp;

                        return <Timeline.Item title={message.Message}>
                            <Text size="xs" mt={4}>{fullDate(time)}</Text>
                        </Timeline.Item>
                    }

                    )
                }
                {/* <Timeline.Item title="Commits">
    <Text size="xs" mt={4}>52 minutes ago</Text>
</Timeline.Item> */}



            </Timeline>

            {/* </ScrollArea> */}

        </Card>
    )
}

export default AlarmCard
